'use client';
import styled from 'styled-components';
import React, { useMemo, useState } from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { BREAKPOINT_PC, BREAKPOINT_SP, zIndexMap } from '@/util/const';
import { IoIosArrowDown } from 'react-icons/io';
export type TabSectionProps = {
  tabUrlList?: { label: string; url?: string; active?: boolean }[];
};
const TabSection: React.FC<TabSectionProps> = (props) => {
  const pathname = usePathname();
  const [expanded, setExpanded] = useState(false);
  const tabForMobile = useMemo(() => {
    return props.tabUrlList?.findLast((it) => {
      return it.active || it.url == pathname;
    });
  }, [props.tabUrlList]);
  return (
    <>
      <Container>
        <GoldWarp>
          {props.tabUrlList?.map(({ label, url, active }, i) => {
            return (
              <React.Fragment key={label}>
                <Link href={url ? url : ''}>
                  <TabLabel
                    $active={active == undefined ? pathname == url : active}
                    className="pc"
                  >
                    {label}
                  </TabLabel>
                </Link>
              </React.Fragment>
            );
          })}
          {tabForMobile && (
            <div
              onClick={(e) => {
                setExpanded(!expanded);
              }}
              className="top-label"
            >
              <TabLabel $active={false} className="sp" as="div">
                {tabForMobile.label}
                <IoIosArrowDown className="right" />
              </TabLabel>
            </div>
          )}
        </GoldWarp>

        <GrayWarp>
          {expanded ? (
            <>
              {props.tabUrlList?.map(({ label, url, active }) => {
                return (
                  <div key={label} onClick={() => setExpanded(false)}>
                    {tabForMobile?.label != label ? (
                      <Link href={url ? url : ''}>
                        <TabLabel $active={false} className="gray">
                          {label}
                        </TabLabel>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                );
              })}
            </>
          ) : (
            <></>
          )}
        </GrayWarp>
      </Container>
    </>
  );
};

export default TabSection;

const TabLabel = styled.div<{ $active: boolean }>`
  display: flex;
  font-weight: 600;
  padding: 12px 16px;
  align-items: center;
  ${({ $active }) => {
    if ($active) {
      return `
        background: var(--background-primary);
        border-radius: 2px 2px 0px 0px;
        pointer-events: none;
        cursor: default;
      `;
    } else {
      return `
        &:hover {
          cursor: pointer;
          background:var(--color-hover-gold, #dbcaa0); 
        }
      `;
    }
  }}
  a {
    color: inherit;
    text-decoration: none;
  }
  .right {
    position: absolute;
    right: 15px;
  }
  @media (max-width: ${BREAKPOINT_SP}) {
    font-size: 1.25rem;
    line-height: 150%;
    &:hover {
      background: var(--color-gold);
    }
  }
`;

const GoldWarp = styled.div`
  background: var(--color-gold);
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  @media (max-width: ${BREAKPOINT_SP}) {
    display: flex;
    justify-content: center;
    position: sticky;
    top: 0px;
    .top-label {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
  }
  a {
    color: inherit;
    text-decoration: none;
  }
`;

const GrayWarp = styled.div`
  background: var(--gray-300-border);
  width: 100%;
  position: absolute;
  z-index: ${zIndexMap.header};
  margin-top: 54px;
  text-align: center;
  .gray {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid var(--gray-400-border, #a1a1aa);
  }
  a {
    color: inherit;
    text-decoration: none;
  }
`;

const Container = styled.div`
  background: var(--color-gold);
  width: 100%;
  @media (max-width: ${BREAKPOINT_SP}) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    .pc {
      display: none !important;
    }
  }
  @media (min-width: ${BREAKPOINT_PC}) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    .sp {
      display: none !important;
    }
  }
`;
